// extracted by mini-css-extract-plugin
export default {"title":"DetailedPrizes_title__fiD5x","prizeContainer":"DetailedPrizes_prizeContainer__hWPJb"};